import React, {createContext, useState, useEffect, useMemo} from 'react';
import {Text, Tabs, TabList, Tab, TabPanels, TabPanel, Flex, Spacer, Button} from '@chakra-ui/react';

import OppClient from '../../components/Maintenance/OpportunityPlan/OppClient';
import OppLocation from '../../components/Maintenance/OpportunityPlan/OppLocation';
import OppEmployee from '../../components/Maintenance/OpportunityPlan/Employee/OppEmployee';
import {useTitle} from '../../components/General/Layout';
import OppBonusEntry from '../../components/Maintenance/OpportunityPlan/OppBonusEntry';
import LoadingWheel from '../../components/General/LoadingWheel';
import {post, get} from '../../service/ApiService';
import {OpportunityPlan, Client as ClientUrls} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';
import {useMutation, useQuery} from 'react-query';
import OppTargetNew from '../../components/Maintenance/OpportunityPlan/OppTargetNew';
import ClientOMaintenanceSelect from '../../components/ClientO/ClientOMaintenanceSelect';
import {useSearchParams, useLocation} from 'react-router-dom';

const ClientOppContext = createContext();

const useClientOpp = () => {
  const context = React.useContext(ClientOppContext);
  if (!context) {
    throw new Error('useData must be used within a <Parent />');
  }
  return context;
};

const tabs = ['client', 'location', 'target', 'employee', 'bonus-entry'];

const OppPlanMaintenance = props => {
  // const ClientContext = createContext();
  // const useClient = () => {
  //   const context = React.useContext(ClientContext);

  //   if (!context) {
  //     throw new Error('useData must be used within a <Parent />');
  //   }

  //   return context;
  // };
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [selectedClientO, setSelectedClientO] = useState(
    searchParams.get('clientO') ? {id: searchParams.get('clientO'), clId: searchParams.get('clId')} : null
  );

  const [client, setClient] = useState(location.state?.client ?? null);
  const [toast, setToast] = useState('');
  const [title, setTitle] = useTitle('Opportunity Plan Maintenance');
  console.log(selectedClientO, client);
  const {isLoading} = useQuery(
    ['client', selectedClientO?.id],
    async () => ({
      client: await get(ClientUrls.GET_CODE + '?clientCode=' + selectedClientO.clId),
      opp: await get(OpportunityPlan.RECORD + '/' + selectedClientO?.id),
    }),
    {
      enabled: selectedClientO !== null,
      onSuccess: ({client, opp}) => {
        const formattedClient = {
          ...client,
          clSince: client?.clSince?.substring(0, client?.clSince.indexOf('T')),
        };

        // Trim all string values
        for (const key in formattedClient) {
          if (typeof formattedClient[key] === 'string') {
            formattedClient[key] = formattedClient[key].trim();
          }
        }

        setClient({client: formattedClient, opp});
      },
      onError: () => {
        setClient(null);
      },
    }
  );

  const {mutate: update, isLoading: isUpdating} = useMutation(() => post(OpportunityPlan.MISSING_PLANS), {
    onSuccess: result => {
      if (result.error) {
        setToast({response: {error: true}, errorMessage: result.error});
      } else {
        setToast({successMessage: 'Successfully updated plans.'});
      }
    },
    onError: () => {
      setToast({response: {error: true}, errorMessage: 'Error updating plans.  Please try again.'});
    },
  });

  useEffect(() => {
    loadTitle();
  }, []);

  const loadTitle = () => {
    setTitle('Opportunity Plan Maintenance');
  };

  const defaultTabIndex = useMemo(() => {
    const tab = searchParams.get('tab');
    if (tab && tabs.includes(tab)) {
      return tabs.indexOf(tab);
    }
    return 0;
  }, [searchParams]);

  const value = useMemo(
    () => ({
      client,
      selectedClientO,
      setSelectedClientO,
    }),
    [client, selectedClientO]
  );

  return (
    <ClientOppContext.Provider value={value}>
      {/* If there's a heavy load for loading all the tabs at once we can add the prop isLazy to Tabs to load each tab separately when clicked */}
      <Tabs
        variant="enclosed"
        mt="3"
        colorScheme="primary"
        isLazy
        onChange={index => {
          searchParams.set('tab', tabs[index]);
          setSearchParams(searchParams, {replace: true, state: {client}});
        }}
        defaultIndex={defaultTabIndex}
      >
        <TabList>
          <Tab>Client</Tab>
          <Tab>Location</Tab>
          <Tab>Target</Tab>
          <Tab>Employee</Tab>
          <Tab>Bonus Entry</Tab>
        </TabList>

        <Flex
          bg="graystone.primary"
          h={{xs: '30', sm: '10'}}
          px="4"
          py="2"
          mt="1"
          alignItems="center"
          flexDir={{base: 'column', lg: 'row'}}
          borderRadius="3"
        >
          <Text color="white">ClientId: {client?.client?.clId}</Text>
          <Spacer />
          <Text color="white">{client?.client?.clCname}</Text>
          <Spacer />

          <Flex alignItems="flex-end" gap={2}>
            <ClientOMaintenanceSelect />
            <Button mr="2" onClick={() => update()} disabled={isUpdating}>
              Update
            </Button>
          </Flex>
        </Flex>

        {isLoading ? (
          <LoadingWheel />
        ) : (
          <TabPanels>
            <TabPanel px="0">
              <OppClient />
            </TabPanel>
            <TabPanel px="0">
              <OppLocation />
            </TabPanel>
            <TabPanel px="0">
              <OppTargetNew />
            </TabPanel>
            <TabPanel px="0">
              <OppEmployee />
            </TabPanel>
            <TabPanel px="0">
              <OppBonusEntry />
            </TabPanel>
          </TabPanels>
        )}
      </Tabs>
      <ErrorHelper toastResponse={toast} />
    </ClientOppContext.Provider>
  );
};

export {OppPlanMaintenance, useClientOpp};
